module.exports = __webpack_public_path__ + "static/media/profileYellow.d3ccbace.svg";